import { jsx as o } from "react/jsx-runtime";
import { Suspense as e } from "react";
import { Loader as t } from "../../../shared/ui/Loader/Loader.js";
function n({ children: r }) {
  return /* @__PURE__ */ o(e, { fallback: /* @__PURE__ */ o(t, {}), children: r });
}
export {
  n as SuspenseLayout
};
